var common = require("../../utiles/common.js");
var service = require("../../utiles/service");
var layUtils = require("../../utiles/layUtils");
var metaUtils = require("../../utiles/metaTypeUtils");
var columns = require("./actionCol");

module.exports = {
  register: function () {
    document.createElement("action-log");
    ko.components.register("action-log", {
      viewModel: function (params) {
        var $this = this;
        $this.user = common.getStorage().user;
        console.log($this.user);

        $this.renderAttr = function (attr, data) {
          var setter = metaUtils.getAddon(
            metaUtils.metaType.QNAME_ATTRIBUTE_ADDON_SETTER,
            attr.addons
          );
          return metaUtils.getValue(attr, data, setter);
        };

        $this.renderList = function (dataTypeQualifyName, id, cols) {
          layUtils.table({
            elem: "#" + id,
            height: 600,
            url: "/auth/dataSearch/queryManageViewData",
            method: "post",
            where: {
              dataTypeQualifyName: dataTypeQualifyName,
              condition: {
                individualDisplayName: $this.user.individualDisplayName,
              },
              sort: [
                {
                  attributeCode: "createdDate",
                  type: "DESC",
                },
              ],
            },
            page: true,
            cols: cols,
          });
        };

        $this.renderList(
          metaUtils.metaType.QNAME_BUSINESS_LOG,
          "actionLog",
          columns.ActionLog
        );
      },
      template: require("./actionLog.html"),
    });
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/component/actionLog/actionLog.js
// module id = 205
// module chunks = 0